import React from 'react';
import classNames from 'classnames';
import './styles.css';

export interface PageBodyProps extends React.PropsWithChildren {
  noPadding?: boolean;
  displayFlex?: boolean;
  hideScrollbar?: boolean;
  className?: string;
}

export function PageBody({ displayFlex, hideScrollbar, noPadding, children, className }: PageBodyProps) {
  const classes = classNames(
    'page-container-body bg-white w-full top-round',
    { 'p-3': !noPadding },
    { 'flex flex-col': displayFlex },
    hideScrollbar ? 'page-container-body-hide-scroll' : 'overflow-auto',
    className
  );
  return (<div className={classes}>{children}</div>);
}

export default PageBody;
